import { reducer } from "redux-form";

const fakeInitialState = {
  "sex-age": {
    registeredFields: {
      sex: {
        name: "sex",
        type: "Field",
        count: 0
      },
      birthday: {
        name: "birthday",
        type: "Field",
        count: 0
      },
      weight: {
        name: "weight",
        type: "Field",
        count: 0
      },
      height: {
        name: "height",
        type: "Field",
        count: 0
      }
    },
    fields: {
      sex: {
        visited: true,
        touched: true
      },
      weight: {
        visited: true,
        touched: true
      },
      height: {
        visited: true,
        touched: true
      },
      birthday: {
        touched: true
      }
    },
    values: {
      sex: "female",
      birthday:
        "Sat Aug 11 2001 00:00:00 GMT+0300 (Eastern European Summer Time)",
      age: 18,
      weight: "190",
      height: "190"
    },
    anyTouched: true,
    submitSucceeded: true
  }
};

const useFakeData = () => {
  return (
    process.env.REACT_APP_ENV !== "production" &&
    !!localStorage.getItem("fakeForm")
  );
};

const initialState = useFakeData() ? fakeInitialState : {};

export const formReducer = (state = initialState, action) => {
  return reducer(state, action);
};



// WEBPACK FOOTER //
// ./src/modules/forms/forms-reducer.js